import React from "react";
import Header from "./Components/Header";
import HeroSection from "./Components/HeroSection";
import Features from "./Components/Features";
import HowItWorks from "./Components/HowItWorks";
import AboutUs from "./Components/AboutUs";
import Footer from "./Components/Footer";
import Testimonial from "./Components/Testimonial";
import DownloadApp from "./Components/DownloadApp";

const Home = () => {
  return (
    <>
      <Header />
      <HeroSection />
      <Features />
      <AboutUs />
      <HowItWorks />
      <Testimonial />
      <DownloadApp />
      <Footer />
    </>
  );
};

export default Home;
